import React from 'react';
import { Container } from './PropertyGroup.styles';

var PropertyGroup = function PropertyGroup(_ref) {
  var children = _ref.children,
      isActive = _ref.isActive;
  return React.createElement(Container, {
    isActive: isActive
  }, children);
};

export default PropertyGroup;